import { map } from "rxjs/operators";
import { GET, POST, PUT } from "../../../../module/services/fetch";
import { IChainEntitlementsUpdateBody } from "../ApplicationsAbilitationsManagementStepFive/module/constants";

export const fetchApplicationsRequest = (payload: any) => {
  const { requestBody, sortBy } = payload;
  return POST(
    `admin/applications/find${
      sortBy && sortBy.length > 0
        ? `?sortField=${sortBy[0].id}&sortOrder=${
            sortBy[0].desc ? "desc" : "asc"
          }`
        : ""
    }`,
    requestBody
  ).pipe(map((response: any) => response));
};

export const fetchApplicationPropertiesRequest = (payload: any) => {
  const { applicationId, identitySystemId } = payload;
  return GET(
    `admin/applications/${applicationId}/enrichment?identitySystemId=${identitySystemId}`
  ).pipe(map((response: any) => response));
};

export const updatePropertiesRequest = (body: any) => {
  return PUT(`admin/applications`, body).pipe(map((response: any) => response));
};

export const fetchEntitlementsRequest = (payload: any) => {
  const { requestBody, sortBy } = payload;
  return POST(
    `entitlements/find${
      sortBy && sortBy.length > 0
        ? `?sortField=${
            sortBy[0].id ===
            "show_on_frontend_console_admin_applications_abilitations_mgmt"
              ? "showOnFrontend"
              : sortBy[0].id
          }&sortOrder=${sortBy[0].desc ? "desc" : "asc"}`
        : ""
    }`,
    requestBody
  ).pipe(map((response: any) => response));
};

export const fetchEntitlementCustomPropertiesRequest = (payload: any) => {
  const { entitlementId, identitySystemId } = payload;
  return GET(
    `admin/entitlements/${entitlementId}/enrichment?identitySystemId=${identitySystemId}`
  ).pipe(map((response: any) => response));
};

export const updateEntitlementPropertiesRequest = (body: any) => {
  return PUT(`admin/entitlements`, body).pipe(map((response: any) => response));
};

export const fetchChainEntitlementsRequest = (body: {
  entitlementId: string;
  identitySystemId: string;
}) => {
  const { entitlementId, identitySystemId } = body;
  return GET(
    `entitlements/chainEntitlements?entitlementId=${entitlementId}&identitySystemId=${identitySystemId}`
  ).pipe(map((response: any) => response));
};

export const updateChainEntitlementsRequest = (
  body: IChainEntitlementsUpdateBody
) => {
  return POST(`entitlements/chainEntitlements/update`, body).pipe(
    map((response: any) => response)
  );
};

export const fetchGetBao = (request: any = {}) => {
  const req = request ? request : {};
  //W1 - ProjectMetro user/find
  return POST("admin/user/find", req).pipe(map((response: any) => response));
};
